// 这段代码实现了一个数字格式化函数 ，
// 用于将数字格式化为指定小数位数的字符串
// 四舍五入和本地化格式化
export const formatNumber = (number, decimalPlaces = 2) => {
    if (!number) return 0;
    const factor = Math.pow(10, decimalPlaces);
    let returnNumber = Math.round(number * factor) / factor;
    return returnNumber.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: decimalPlaces });
};

export const calculatePercentage = (number, percent, decimalPlaces = 2) =>{
    return formatNumber(((number * percent) / 100),decimalPlaces);
}